import { useEffect, useState } from "react";
import { Brand } from "../Brand";
import { Button } from "../ui/button";
import { useAuth } from "../../context/AuthContext";
import { Moon, Sun, LogOut, CircleDot } from "lucide-react";
import { toast } from "sonner";

function StatusPill({ label, ok }) {
  return (
    <div className="hidden md:flex items-center gap-1.5 rounded-full border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/60 px-2.5 py-1 text-xs font-medium text-slate-600 dark:text-slate-300">
      <CircleDot className={`h-3 w-3 ${ok ? "text-emerald-500" : "text-slate-400"}`} />
      {label}
    </div>
  );
}

export function TopBar() {
  const { user, logout } = useAuth();
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
  }, [dark]);

  const initials = (user?.name || user?.email || "?")
    .split(" ")
    .map((s) => s[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const handleLogout = async () => {
    await logout();
    toast.success("Signed out");
  };

  return (
    <header className="h-16 sticky top-0 z-50 flex items-center justify-between px-4 sm:px-6 border-b border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md">
      <div className="flex items-center gap-4">
        <Brand />
        <div className="hidden lg:flex items-center gap-2 pl-4 border-l border-slate-200 dark:border-slate-700">
          <StatusPill label="Xero: Ready" ok />
          <StatusPill label="Netcash: Ready" ok />
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        <Button variant="ghost" size="icon" onClick={() => setDark((d) => !d)} data-testid="theme-toggle-button" aria-label="Toggle theme" className="text-slate-500">
          {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>

        <div className="hidden sm:flex items-center gap-2.5 pl-1">
          <div className="h-8 w-8 rounded-full bg-slate-900 dark:bg-blue-600 text-white flex items-center justify-center text-xs font-semibold" data-testid="user-avatar">
            {initials}
          </div>
          <div className="leading-tight">
            <div className="text-sm font-semibold text-slate-800 dark:text-slate-100" data-testid="user-name">{user?.name}</div>
            <div className="text-[11px] uppercase tracking-wide font-medium text-slate-400" data-testid="user-role">{user?.role === "admin" ? "Administrator" : "Financial Clerk"}</div>
          </div>
        </div>

        <Button onClick={handleLogout} variant="outline" className="h-9 border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 font-semibold" data-testid="logout-button">
          <LogOut className="h-4 w-4 sm:mr-2" />
          <span className="hidden sm:inline">Logout</span>
        </Button>
      </div>
    </header>
  );
}
